import { render, staticRenderFns } from "./EduLoginButton.vue?vue&type=template&id=34d3afbe&scoped=true&"
import script from "./EduLoginButton.vue?vue&type=script&lang=js&"
export * from "./EduLoginButton.vue?vue&type=script&lang=js&"
import style0 from "./EduLoginButton.vue?vue&type=style&index=0&id=34d3afbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d3afbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
